import { render, staticRenderFns } from "./rewardMtt.vue?vue&type=template&id=a8036b66"
import script from "./rewardMtt.vue?vue&type=script&lang=js"
export * from "./rewardMtt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports